@import '../../constants/spacing.module.less';

.modalHeader {
  height: auto;
  min-height: auto;
  line-height: normal;
  padding: @space-16;
}

.modalBody {
  padding: @space-16 @space-16 @space-24;
  overflow-y: visible;
}
